import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Editorial%20flat%20lay%20photography%20of%20premium%20casual%20streetwear%20products%20including%20white%20sneakers%20cream%20knit%20sweater%20and%20minimalist%20accessories%20arranged%20artfully%20on%20a%20light%20stone%20textured%20surface%20with%20soft%20directional%20window%20lighting%20from%20left%20side%20creating%20elegant%20depth%20and%20gentle%20shadows%20modern%20aesthetic%20no%20text%20no%20logos&width=1800&height=1200&seq=hero-bg-v3&orientation=landscape"
          alt="CSSBuySpreadsheet - Produtos organizados"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 py-20 md:py-0">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16 max-w-7xl mx-auto">
          <div className="flex-1 text-left w-full">
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl leading-tight text-background-50 mb-6">
              CSSBuy<span className="text-primary-400">Spreadsheet</span>
              <br />
              <span className="italic font-light text-2xl md:text-4xl lg:text-5xl">
                A Melhor Planilha CSSBuy Atualizada em 2026
              </span>
            </h1>

            <p className="text-base md:text-lg text-background-200/90 max-w-xl mb-8 leading-relaxed">
              Descubra os melhores links CSSBuy, vendedores confiáveis, planilhas
              atualizadas e guias completos para comprar da China com segurança.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-10">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all text-center whitespace-nowrap cursor-pointer"
              >
                CSSBuy Sheet
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-8 py-3.5 border-2 border-background-200/60 text-background-50 rounded-full text-sm font-semibold hover:bg-background-50 hover:text-foreground-900 transition-all text-center whitespace-nowrap cursor-pointer"
              >
                Buy It Now
              </a>
              <Link
                to="/artigo/cssbuy-sheet-guia-completo"
                className="px-8 py-3.5 border-2 border-background-200/60 text-background-50 rounded-full text-sm font-semibold hover:bg-background-50 hover:text-foreground-900 transition-all text-center whitespace-nowrap cursor-pointer"
              >
                Guia de Compras
              </Link>
            </div>

            <div className="flex flex-wrap gap-3 md:gap-5">
              {[
                { icon: "ri-checkbox-circle-line", text: "Atualizado diariamente" },
                { icon: "ri-shield-check-line", text: "Vendedores verificados" },
                { icon: "ri-guide-line", text: "Guias para iniciantes" },
                { icon: "ri-secure-payment-line", text: "Compras seguras" },
              ].map((badge) => (
                <span
                  key={badge.text}
                  className="flex items-center gap-2 text-xs md:text-sm text-background-200/90"
                >
                  <i className={`${badge.icon} text-primary-400`}></i>
                  {badge.text}
                </span>
              ))}
            </div>
          </div>

          <div className="flex-1 hidden lg:block">
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=Vertical%20editorial%20fashion%20photography%20of%20a%20single%20pristine%20white%20designer%20sneaker%20placed%20elegantly%20on%20a%20warm%20sandstone%20surface%20with%20natural%20morning%20light%20casting%20long%20delicate%20shadows%20sophisticated%20minimal%20composition%20with%20negative%20space%20premium%20product%20shot%20no%20text&width=800&height=900&seq=hero-side-v3&orientation=portrait"
                alt="Produtos CSSBuy premium"
                className="w-full h-auto rounded-2xl object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}